import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Foundation } from '@models';

@Component({
  selector: 'lfx-dev-analytics-foundation-card',
  templateUrl: './dev-analytics-foundation-card.component.html',
  styleUrls: ['./dev-analytics-foundation-card.component.scss'],
})
export class DevAnalyticsFoundationCardComponent {
  @Input() foundation: Foundation;
  @Output() viewFoundationEvent = new EventEmitter();

  showOverlayOnFoundationCard = false;
  linechartOption = 'all';

  constructor() {}

  onHoverStatistics(option) {
    this.linechartOption = option;
  }

  onViewFoundation() {
    this.viewFoundationEvent.emit();
  }
}
